import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';
import { useParams } from 'react-router-dom';
import "./user.css"

const MyFollowers = () => {
    const [myFollowers, setMyFollowers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const [isFriend, setIsFriend] = useState(null)
    const [isFollowing, setIsFollowing] = useState(null)

    const { user } = useParams()

    useEffect(() => {
        const checkIsFriend = async () => {
            try {
                const response = await api.get(`/users/${user}/check`)
                if (response) {
                    setIsFriend(response?.data)
                }
            } catch (error) {
                toast.error(error.response?.data.message)
            }
        }
        checkIsFriend()
    }, [user])

    useEffect(() => {
        const getMyFollowers = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/community/followers`, { params: { page } });
                // console.log(response)
                setMyFollowers(response?.data);

                if (response?.data.length < 20) {
                    setHasMore(false)
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch followers");
            } finally {
                setIsLoading(false);
            }
        };

        getMyFollowers();
    }, [page, user]);

    const handleRefresh = async () => {
        setPage(1)
        setMyFollowers([])
    }
    const sendUnfollowRequest = async (id) => {
        try {
            console.log(id)
        } catch (error) {

        }
    }

    return (
        <div className='users-page-container'>
            <div className="userfriends-header">
                <h3>people following me</h3>
                {/* {isFriend && <button className="add-frd-btn" onClick={() => sendUnfollowRequest(user)}>unfollow</button>} */}
            </div>
            <InfiniteScroll
                dataLength={myFollowers.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="friends-list">
                    {
                        isLoading && <Loader />
                    }
                    {!isLoading && myFollowers.length === 0 &&
                        <p className="not-found-msg">No followers found !!</p>
                    }
                    {
                        myFollowers && myFollowers.map((frd) => (
                            <UserCard user={frd} />
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    );
};

export default MyFollowers;
